import React from 'react';
import ActivateTargetAPI from '../../../containers/activate-target/ActivateTargetAPI';
import { GlobalSearchItem, GlobalSearchRegistryItem } from '../../interfaces/global-search';
import { GenericListItemContent, GenericListItemContentProps } from './GenericListItemContent/GenericListItemContent';
import { TARGET_TYPES } from '../../../containers/activate-target/models/target-type';
import { GlobalSearchEntityCommonData } from './interfaces/global-search-entity';

export const GLOBAL_SEARCH_TARGET_KEY = 'targets';

export const GlobalSearchTargetRegistry: GlobalSearchRegistryItem<GlobalSearchEntityCommonData> = {
  key: GLOBAL_SEARCH_TARGET_KEY,
  title: 'Targets',
  maxItemsWhenNoFiltersApplied: 2,
  sortOrder: 5,
  filters: [
    {
      value: GLOBAL_SEARCH_TARGET_KEY,
      label: 'Targets'
    }
  ],
  viewAllRoute: '/activation?tab=target',
  inMemoryFiltering: true,
  dataResolver: () => ActivateTargetAPI.getTargets()
    .then(res => {
      const targets = res.data.map(GlobalSearchTargetFactory);
      return [...targets];
    }),
  renderItem: (item) => {
    const props: GenericListItemContentProps = {
      suffixIcon: item.icon,
      primaryText: item.name,
      secondaryText: item.data.displayType,
      primaryLogoProps: {
        logoURL: item.data.logoUrl,
        darkModeLogoURL: item.data.darkModeLogoUrl,
        primaryColor: TARGET_TYPES[item.data.type]?.primaryColor,
        darkModePrimaryColor: TARGET_TYPES[item.data.type]?.darkModePrimaryColor
      },
      primaryLogoTooltip: item.data.displayType
    };

    return (
      <GenericListItemContent {...props} />
    );
  }
};

export function GlobalSearchTargetFactory(
  rawTarget: any
): GlobalSearchItem<GlobalSearchEntityCommonData> {
  return {
    data: {
      name: rawTarget.name,
      type: rawTarget.type,
      displayType: rawTarget.type_display_name,
      logoUrl: rawTarget.type_logo_url,
      darkModeLogoUrl: rawTarget.type_dark_mode_logo_url ?? rawTarget.type_logo_url,
    },
    key: `${rawTarget.type}-target-${rawTarget.seq_id}`,
    name: rawTarget.name,
    exitURL: `/target/${rawTarget.seq_id}/overview`,
    icon: 'target',
    searchKeywords: [rawTarget.name, rawTarget.type, rawTarget.type_display_name]
  };
}
